// src/modules/shared/dashboard/formatters.ts
// Shared value formatters used across all module dashboard KPI registrations.

export const fmtBRL = (n: number): string => {
  if (n >= 1_000_000) return `R$ ${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `R$ ${(n / 1_000).toFixed(1)}k`;
  return `R$ ${n.toLocaleString("pt-BR")}`;
};

export const fmtPct = (n: number): string => `${n.toFixed(1)}%`;

export const fmtDays = (n: number): string => `${n}d`;

export const fmtHours = (n: number): string => `${n.toLocaleString("pt-BR")}h`;
